import React from "react";
import { NavLink, useLocation } from "react-router-dom";

// Mirrors proposed UI/partials.js NAV[]
interface NavItem {
  key: string;
  label: string;
  icon: string;
  to: string;
  section: "Monitoring" | "Manage";
}

const NAV: NavItem[] = [
  {
    key: "overview",
    label: "Dashboard",
    icon: "bi-speedometer2",
    to: "/reviewer/overview",
    section: "Monitoring",
  },
  {
    key: "charts",
    label: "Charts",
    icon: "bi-graph-up",
    to: "/reviewer/dashboard",
    section: "Monitoring",
  },
  {
    key: "reports",
    label: "Reports",
    icon: "bi-file-earmark-bar-graph",
    to: "/reviewer/reports",
    section: "Monitoring",
  },
  {
    key: "projects",
    label: "Projects",
    icon: "bi-folder",
    to: "/admin/project-setup",
    section: "Manage",
  },
  {
    key: "activities",
    label: "Activities",
    icon: "bi-list-check",
    to: "/admin/activities",
    section: "Manage",
  },
  {
    key: "alert-profiles",
    label: "Action Profiles",
    icon: "bi-shield-exclamation",
    to: "/admin/alert-profiles",
    section: "Manage",
  },
  {
    key: "distortion-pairs",
    label: "Angular Distortion Pairs",
    icon: "bi-rulers",
    to: "/admin/distortion-pairs",
    section: "Manage",
  },
  {
    key: "device-logs",
    label: "Checkpoints Logs",
    icon: "bi-clock-history",
    to: "/admin/device-logs",
    section: "Manage",
  },
];

const Sidebar: React.FC = () => {
  const location = useLocation();
  const role = new URLSearchParams(location.search).get("role");
  let sections: Array<"Monitoring" | "Manage"> =
    role === "reviewer"
      ? ["Monitoring"]
      : role === "admin"
        ? ["Manage"]
        : ["Monitoring", "Manage"];

  if (process.env.NODE_ENV === "development")
    sections = ["Monitoring", "Manage"];

  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <div className="logo">
          <img
            src={`${process.env.PUBLIC_URL}/buildking-logo.png`}
            alt="HSP Logo"
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        </div>
        <span>HSP Monitoring</span>
      </div>
      <br />
      {process.env.NODE_ENV === "development" && (
        <sub style={{ color: "red", textAlign: "center" }}>
          all sidebar content shown in DEV
        </sub>
      )}
      {sections.map((sec) => {
        const items = NAV.filter((n) => n.section === sec);
        if (!items.length) return null;
        return (
          <React.Fragment key={sec}>
            <ul className="sidebar-nav">
              {items.map((n) => (
                <li key={n.key}>
                  <NavLink
                    to={{ pathname: n.to, search: location.search }}
                    className={({ isActive }) =>
                      isActive ? "active" : undefined
                    }
                  >
                    <i className={`bi ${n.icon}`} />
                    {n.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </React.Fragment>
        );
      })}
    </aside>
  );
};

export default Sidebar;
